var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8948 13.2249C38.8481 12.9862 38.5523 12.8927 38.381 13.0692L35.9418 15.5087C35.7601 15.6903 35.511 15.7734 35.2567 15.7422L33.0822 15.4568C32.8019 15.4204 32.5788 15.1973 32.5424 14.917L32.257 12.7422C32.2258 12.4879 32.3089 12.2388 32.4905 12.0571L34.9298 9.61761C35.101 9.44633 35.0076 9.14528 34.7689 9.09858C32.9472 8.74045 30.9698 9.3581 29.6777 10.9515C28.5567 12.3321 28.2557 14.1903 28.7747 15.8253L16.916 27.6852C14.84 27.0157 12.4373 27.6541 10.9997 29.6108C9.61406 31.5001 9.67633 34.1627 11.1399 35.995C13.1431 38.5072 16.8176 38.6577 19.0231 36.4518C20.4762 34.9985 20.9018 32.9121 20.3102 31.0797L32.1742 19.2145C33.9802 19.7907 36.0354 19.365 37.4679 17.9325C38.7498 16.6505 39.2273 14.8702 38.9003 13.2145L38.8948 13.2249ZM18.198 32.154L17.5389 34.6194C17.4973 34.7751 17.378 34.8945 17.2223 34.936L14.7571 35.5952C14.6014 35.6367 14.4405 35.5952 14.3263 35.481L12.5203 33.6748C12.4061 33.5606 12.3646 33.3997 12.4061 33.244L13.0652 30.7785C13.1068 30.6228 13.2261 30.5035 13.3818 30.4619L15.847 29.8028C16.0027 29.7612 16.1636 29.8028 16.2777 29.9169L18.0838 31.7232C18.198 31.8374 18.2395 31.9983 18.198 32.154ZM28.2142 20.5173L21.4208 27.3114C21.317 27.4152 21.1873 27.462 21.0523 27.462C20.9174 27.462 20.7876 27.41 20.6838 27.3114C20.4814 27.109 20.4814 26.782 20.6838 26.5796L27.4773 19.7855C27.6797 19.5831 28.0066 19.5831 28.209 19.7855C28.4114 19.9879 28.4114 20.3149 28.209 20.5173H28.2142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering);
export default __webpack_public_path__ + "static/media/engineering.b05017cfc615ca15ce529692c313c341.svg";
export { ForwardRef as ReactComponent };